import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const cccStandardsShortInfosAdapter = getAdapter();

const cccStandardsShortInfosSlice = createSlice({
  name: 'cccStandardsShortInfos',
  initialState: cccStandardsShortInfosAdapter.getInitialState(),
  reducers: {
    setcccStandardsShortInfos: (state, { payload: { cccStandardsShortInfos } }) => {
      cccStandardsShortInfosAdapter.setAll(state, cccStandardsShortInfos);
    },
  },
});

const selectors = cccStandardsShortInfosAdapter.getSelectors(({ cccStandardsShortInfos }) => cccStandardsShortInfos);

export const getcccStandardsShortInfos = (state) => selectors.selectAll(state);

export const { setcccStandardsShortInfos } = cccStandardsShortInfosSlice.actions;

export default cccStandardsShortInfosSlice.reducer;